module.exports = __webpack_public_path__ + "img/2.4266a3a1.png";